import { render, staticRenderFns } from "./PrefixoField.vue?vue&type=template&id=e3d7975e&scoped=true&"
import script from "./PrefixoField.vue?vue&type=script&lang=js&"
export * from "./PrefixoField.vue?vue&type=script&lang=js&"
import style0 from "./PrefixoField.vue?vue&type=style&index=0&id=e3d7975e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d7975e",
  null
  
)

export default component.exports